import React, { useState } from "react";
import ImageModal from "./ImageModal";
import CardRail from "./CardRail";
import FadeInSection from "./FadeInSection";
import SectionHeading from "./SectionHeading";

const EVENTS = [
    {
        id: 1,
        title: "Azure OpenAI Service in GitHub Models",
        image: "/assets/events/github_model.png",
        meta: "June 2025",
    },
    {
        id: 2,
        title: "Hola Mozilla — DevSecOps 101",
        image: "/assets/events/HolaMozilla.png",
        meta: "September 2025",
    },
];

const Events = () => {
    const [modal, setModal] = useState({ open: false, src: "", title: "" });

    const openModal = (src, title) => setModal({ open: true, src, title });
    const closeModal = () => setModal({ open: false, src: "", title: "" });

    return (
        <section id="events" className="section">
            <div className="shell">
                <FadeInSection>
                    <SectionHeading index="05" title="events attended" />
                </FadeInSection>
                <FadeInSection>
                    <CardRail items={EVENTS} onImageClick={openModal} />
                </FadeInSection>
            </div>

            <ImageModal
                open={modal.open}
                src={modal.src}
                title={modal.title}
                onClose={closeModal}
            />
        </section>
    );
};

export default Events;
